import { z } from 'zod'

export const conditionallyRequiredNumber = (isIt: boolean) =>
	z
		.string()
		.refine(
			(value) => {
				if (value !== undefined) {
					if (value.trim().length > 0 || isIt) {
						return true
					} else {
						return false
					}
				}
				return true
			},
			{ message: 'Required field' },
		)
		.refine(
			(value) => {
				if (value.trim().length > 0 || isIt) {
					const number = Number(value)
					if (!isNaN(number)) {
						return true
					} else {
						return false
					}
				}
			},
			{ message: 'Not a number' },
		)
		.refine(
			(value) => {
				if (value.trim().length >= 0) {
					const number = Number(value)
					return number >= 0
				}
			},
			{ message: 'Not a positive number' },
		)
		.transform((value) => {
			if (isIt) {
				return 0
			}
			return Number(value)
		})

export const RequiredNumber = z
	.string()
	.min(1, { message: 'Required field' })
	.refine(
		(value) => {
			if (value.trim().length >= 0) {
				const number = Number(value)
				if (!isNaN(number)) {
					return true
				} else {
					return false
				}
			}
		},
		{ message: 'Not a number' },
	)
	.refine(
		(value) => {
			if (value.trim().length >= 0) {
				const number = Number(value)
				return number >= 0
			}
		},
		{ message: 'Not a positive number' },
	)
	.transform((value) => Number(value))
